import { icon, node } from "~/util/dom";
import Content from "./content";

export default class Address extends Content {
	_build() {
		this._dom.container.classList.add("content-address");

		if (this._data.locationMain) {
			const address = node("p", { className: "address", textContent: this._data.locationMain });

			this._dom.container.appendChild(address);

			if (this._data.locationSub) {
				Mapy.getComponent("logger").log("adresaShow");
				address.classList.add("with-sublocation");
				address.appendChild(icon("dropdown"));
				address.appendChild(icon("dropup"));

				const locationSub = node("p", { className: "sublocation", textContent: this._data.locationSub });

				this._dom.container.appendChild(locationSub);
				// eventy
				address.addEventListener("pointerdown", () => {
					this._dom.container.classList.toggle("open");
					if (this._dom.container.classList.contains("open")) {
						Mapy.getComponent("logger").log("click", {
							text: "adresa-rozbaleni",
						});
					} else {
						Mapy.getComponent("logger").log("click", {
							text: "adresa-sbaleni",
						});
					}
				});
			}
		}
	}
}
